import PropTypes from "prop-types"
import withPathItems from "../graphql/withPathItems"
import LearnPathList from "./LearnPathList"

// TODO: eventually move other learn path components here (i.e. LearnPathControls)

const LearnPath = (props) => {
  return <LearnPathList {...props} />
}

LearnPath.propTypes = {
  id: PropTypes.number,
  cohort_id: PropTypes.number
}

export default withPathItems(LearnPath)
